import React from 'react';
import { Link } from 'react-router-dom';
import './Methodology.css';

interface Step {
  number: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const steps: Step[] = [
  {
    number: '01',
    title: 'الاستكشاف والفهم',
    description:
      'أبدأ بالاستماع إليك بعمق وفهم متطلباتك وأهدافك العملية. أطرح الأسئلة الصحيحة لضمان فهم المشكلة الحقيقية قبل أي تفكير في الحل التقني.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="7" stroke="#0369A1" strokeWidth="1.8" />
        <path d="M16 16L20 20" stroke="#0369A1" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: '02',
    title: 'التصميم والتخطيط',
    description:
      'أرسم خارطة طريق تقنية واضحة. أختار التقنيات المناسبة لطبيعة المشروع، وأصمم هيكل النظام لضمان قابلية التوسع والصيانة على المدى البعيد.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="#0369A1" strokeWidth="1.8" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="#0369A1" strokeWidth="1.8" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="#0369A1" strokeWidth="1.8" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="#0369A1" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    number: '03',
    title: 'التطوير والبناء',
    description:
      'أكتب كوداً نظيفاً ومنظماً يتبع أفضل الممارسات الصناعية. أطوّر بشكل تدريجي مع تواصل مستمر للحصول على تغذية راجعة وضمان التوافق مع رؤيتك.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M8 6L3 12L8 18" stroke="#0369A1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16 6L21 12L16 18" stroke="#0369A1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 4L10 20" stroke="#0369A1" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    number: '04',
    title: 'الاختبار والمراجعة',
    description:
      'أختبر كل جزء من النظام بدقة قبل التسليم. أراجع الأداء والأمان لأضمن أن المشروع يعمل بكفاءة وموثوقية في بيئة الإنتاج.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="5" y="4" width="14" height="17" rx="2" stroke="#0369A1" strokeWidth="1.8" />
        <path d="M9 11L11 13L15 9" stroke="#0369A1" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 2H15V5H9V2Z" stroke="#0369A1" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const Methodology: React.FC = () => {
  return (
    <section className="methodology" id="approach">
      <div className="methodology-inner">
        <div className="methodology-header">
          <div className="methodology-title-group">
            <div className="methodology-icon" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3 4L6 7L13 2M3 9L6 12L13 7M3 14L6 14"
                  stroke="white"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h2 className="methodology-title">منهجية العمل</h2>
          </div>

          <Link to="/approach" className="methodology-browse">
            <span>قراءة المزيد</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M9 3.5L5.5 7L9 10.5" stroke="#0369A1" strokeWidth="1.17" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
        </div>

        <div className="methodology-grid">
          {steps.map((step) => (
            <article key={step.number} className="method-card">
              <div className="method-card-top">
                <div className="method-card-icon" aria-hidden="true">
                  {step.icon}
                </div>
                <span className="method-card-number">{step.number}</span>
              </div>
              <h3 className="method-card-title">{step.title}</h3>
              <p className="method-card-description">{step.description}</p>
              <span className="method-card-watermark" aria-hidden="true">
                {step.number}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Methodology;
